import { FC } from 'react';
import { TCommentIcon } from './EditorCommentsContainer';
import IconButton from './IconButton';
import { EItemScreenMode, useItemScreenStore } from '@modules/items';
import useCommentStore from '@modules/comments/stores/useCommentStore';
import { NEW_COMMENT_ID } from '@modules/comments/constants';
import { CommentAddFilled, CommentFilled, CommentRegular } from '@fluentui/react-icons';

const GAP_BETWEEN_ICONS = 1.1; // in rem

// eslint-disable-next-line react-refresh/only-export-components
export const ICON_TOP_OFFSET = -3; // in px

/**
 * SingleIcon: an absolutely-positioned button for one comment.
 */
const SingleIcon: FC<{
  topPos: number;
  icon: TCommentIcon;
  index: number;
}> = ({ topPos, icon, index }) => {
  const { setScreenMode } = useItemScreenStore();
  const { setSelectedCommentId, selectedCommentId } = useCommentStore();

  // Handle selecting a specific comment from the menu.
  const handleSelect = () => {
    setScreenMode(EItemScreenMode.COMMENTS);
    setSelectedCommentId(icon.id);
  };

  const isNewComment = icon.id === NEW_COMMENT_ID;
  const isSelected = icon.id === selectedCommentId;
  const Icon = isNewComment ? CommentAddFilled : isSelected ? CommentFilled : CommentRegular;

  return (
    <div
      className="absolute"
      style={{
        top: `${topPos + ICON_TOP_OFFSET}px`,
        left: `${index * GAP_BETWEEN_ICONS}rem`,
      }}
    >
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          handleSelect();
        }}
        isSelected={isSelected}
        Icon={Icon}
      />
    </div>
  );
};

export default SingleIcon;
